/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ current: NonNullable<unknown>, total: NonNullable<unknown> }} Ocr_Processing_StatusInputs */

const en_ocr_processing_status = /** @type {(inputs: Ocr_Processing_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Recognizing text in frame ${i?.current} of ${i?.total}`)
};

const fr_ocr_processing_status = /** @type {(inputs: Ocr_Processing_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Reconnaissance du texte dans le cadre ${i?.current} de ${i?.total}`)
};

const de_ocr_processing_status = /** @type {(inputs: Ocr_Processing_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Texterkennung im Frame ${i?.current} von ${i?.total}`)
};

const it_ocr_processing_status = /** @type {(inputs: Ocr_Processing_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Riconoscimento del testo nel riquadro ${i?.current} di ${i?.total}`)
};

const ru_ocr_processing_status = /** @type {(inputs: Ocr_Processing_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Распознавание текста в кадре ${i?.current} из ${i?.total}`)
};

const es_ocr_processing_status = /** @type {(inputs: Ocr_Processing_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Reconociendo texto en el marco ${i?.current} de ${i?.total}`)
};

const zh_cn2_ocr_processing_status = /** @type {(inputs: Ocr_Processing_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`识别帧 ${i?.current} 中的文本（帧 ${i?.total}）`)
};

const ja_ocr_processing_status = /** @type {(inputs: Ocr_Processing_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`フレーム${i?.current}（${i?.total}内）のテキストを認識しています。`)
};

const hi_ocr_processing_status = /** @type {(inputs: Ocr_Processing_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`फ्रेम ${i?.current} के ${i?.total} में टेक्स्ट को पहचानना`)
};

const pt_pt2_ocr_processing_status = /** @type {(inputs: Ocr_Processing_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Reconhecendo o texto no quadro ${i?.current} de ${i?.total}`)
};

/**
* | output |
* | --- |
* | "Recognizing text in frame {current} of {total}" |
*
* @param {Ocr_Processing_StatusInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ocr_processing_status = /** @type {((inputs: Ocr_Processing_StatusInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ocr_Processing_StatusInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ocr_processing_status(inputs)
	if (locale === "de") return de_ocr_processing_status(inputs)
	if (locale === "it") return it_ocr_processing_status(inputs)
	if (locale === "ru") return ru_ocr_processing_status(inputs)
	if (locale === "es") return es_ocr_processing_status(inputs)
	if (locale === "zh-CN") return zh_cn2_ocr_processing_status(inputs)
	if (locale === "ja") return ja_ocr_processing_status(inputs)
	if (locale === "hi") return hi_ocr_processing_status(inputs)
	if (locale === "pt-PT") return pt_pt2_ocr_processing_status(inputs)
	return en_ocr_processing_status(inputs)
});